export const buttonsAction = () => {
  const scrollToForm = () => {
    const form = document.querySelector('.section-form-anchor')
    if (form) {
      window.scrollTo({
        top: form.getBoundingClientRect().top + window.pageYOffset,
        behavior: 'smooth',
      })
    }
  }

  const scrollToBuyByTelForm = () => {
    const form = document.querySelector('.buyByTel')
    if (form) {
      window.scrollTo({
        top: form.getBoundingClientRect().top + window.pageYOffset,
        behavior: 'smooth',
      })
    }
  }

  const scrollToBuyByTelRegionForm = () => {
    const form = document.querySelector('.buyByTelRegion')
    if (form) {
      window.scrollTo({
        top: form.getBoundingClientRect().top + window.pageYOffset,
        behavior: 'smooth',
      })
    }
  }

  const scrollToCallbackRegion = () => {
    const form = document.querySelector('.callbackRegion')
    if (form) {
      window.scrollTo({
        top: form.getBoundingClientRect().top + window.pageYOffset,
        behavior: 'smooth',
      })
    }
  }

  const scrollToAgentsForm = () => {
    const form = document.querySelector('.agents')
    if (form) {
      window.scrollTo({
        top: form.getBoundingClientRect().top + window.pageYOffset,
        behavior: 'smooth',
      })
    }
  }

  const scrollToFrame = () => {
    const frame = document.querySelector('.section-frame-anchor')

    if (frame) {
      window.scrollTo({
        top: window.pageYOffset + frame.getBoundingClientRect().top,
        behavior: 'smooth',
      })
    }
  }

  const scrollToContacts = () => {
    const frame = document.querySelector('.section-contacts-anchor')
    if (frame) {
      window.scrollTo({
        top: frame.getBoundingClientRect().top,
        behavior: 'smooth',
      })
    }
  }
  const modalAuthAccount = () => {
    try {
      window.$nuxt.$store.commit('modal/SET_MODAL', 'modal-auth-account')
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Unable to open the modal window', e)
    }
  }
  const modalAuthLkdms = () => {
    try {
      window.$nuxt.$store.commit('modal/SET_MODAL', 'modal-auth-lkdms')
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Unable to open the modal window', e)
    }
  }
  const modalAuthAppeal = () => {
    try {
      window.$nuxt.$store.commit('modal/SET_MODAL', 'modal-auth-appeal')
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Unable to open the modal window', e)
    }
  }

  const modalNavigation = () => {
    try {
      window.$nuxt.$store.commit('modal/SET_MODAL', 'modal-navigation')
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Unable to open the modal window', e)
    }
  }

  const handlers = {
    scrollToForm,
    scrollToContacts,
    scrollToFrame,
    scrollToBuyByTelForm,
    scrollToBuyByTelRegionForm,
    scrollToAgentsForm,
    scrollToCallbackRegion,
    modalAuthAccount,
    modalAuthLkdms,
    modalAuthAppeal,
    modalNavigation,
  }
  const clickHandler = (
    type: string,
    eventAction?: string | undefined,
    eventCategory?: string | undefined,
    jsCode?: string | undefined
  ) => {
    if (handlers[type]) {
      handlers[type]()
    }

    try {
      if (jsCode?.trim()) {
        eval(jsCode)
      }
    } catch (e) {
      console.error(e)
    }
  }
  return { clickHandler }
}
